/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseFlowMeta } from '../../models/api-response-flow-meta';

export interface CreateAndPublishFlowMeta$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  reference: string;
}

export function createAndPublishFlowMeta(http: HttpClient, rootUrl: string, params: CreateAndPublishFlowMeta$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseFlowMeta>> {
  const rb = new RequestBuilder(rootUrl, createAndPublishFlowMeta.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.query('reference', params.reference, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseFlowMeta>;
    })
  );
}

createAndPublishFlowMeta.PATH = '/v1/api/ui/flow-meta/sync-flow-meta';
